import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList } from "vue";
const _hoisted_1 = { class: "groupFilterContainer" };
const _hoisted_2 = {
    key: 0,
    class: "groupFilter"
};
const _hoisted_3 = { class: "form-group px-2" };
const _hoisted_4 = { class: "groupList" };
const _hoisted_5 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("button", {
                class: "btn btn-primary",
                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.showGroupFilter = !_ctx.showGroupFilter))
            }, [
                (!_ctx.selectedGroup)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode("Filtra per gruppo")
                    ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_ctx.selectedGroup.onOfficeName), 1)
                    ], 64))
            ]),
            (_ctx.showGroupFilter)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _withDirectives(_createElementVNode("input", {
                            type: "text",
                            placeholder: "Cerca...",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.search) = $event)),
                            class: "form-control w-100"
                        }, null, 512), [
                            [_vModelText, _ctx.search]
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", {
                            class: "listItem",
                            onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.select(null)))
                        }, " Tutti "),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredList, (item, i) => {
                            return (_openBlock(), _createElementBlock("div", {
                                class: "listItem",
                                key: i,
                                onClick: ($event) => (_ctx.select(item))
                            }, _toDisplayString(item.onOfficeName), 9, _hoisted_5));
                        }), 128))
                    ])
                ]))
                : _createCommentVNode("", true)
        ]),
        (_ctx.showGroupFilter)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "backgroundBlocker",
                onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.showGroupFilter = false))
            }))
            : _createCommentVNode("", true)
    ], 64));
}
